export default __webpack_public_path__ + "static/media/property_777.dc39dd00.png";